import { render, staticRenderFns } from "./Countdown.vue?vue&type=template&id=bc3d441a&scoped=true&"
import script from "./Countdown.vue?vue&type=script&lang=js&"
export * from "./Countdown.vue?vue&type=script&lang=js&"
import style0 from "./Countdown.vue?vue&type=style&index=0&id=bc3d441a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc3d441a",
  null
  
)

export default component.exports